module.exports = __webpack_public_path__ + "media/practice-web.2e4617b5.mp4";